// @flow

type PropsType = {
    $element: HTMLElement,
    activeIndex: ?number,
    speed: number,
};

class Carousel {
    props: PropsType;
    activeIndex: number;
    numberOfItems: number;
    $element: HTMLElement;
    $items: ?NodeList<HTMLElement>;
    $prevButton: ?HTMLElement;
    $nextButton: ?HTMLElement;

    constructor(props: PropsType) {
        // set props and defaults
        this.props = {
            ...props,
            speed: Number(props.speed || 1000),
        };

        // elements
        this.$element = props.$element;
        this.$items = this.$element
            ? this.$element.querySelectorAll("[data-carousel-item]")
            : null;
        this.$prevButton = this.$element
            ? this.$element.querySelector("[data-carousel-prev]")
            : null;
        this.$nextButton = this.$element
            ? this.$element.querySelector("[data-carousel-next]")
            : null;

        // variables
        this.activeIndex = props.activeIndex || 0;
        this.numberOfItems = this.$items ? this.$items.length : 0;

        // kick off
        this.init();
    }

    bindEvents() {
        if (this.$prevButton) {
            this.$prevButton.addEventListener("click", (): any =>
                this.goToPrevious()
            );
        }

        if (this.$nextButton) {
            this.$nextButton.addEventListener("click", (): any =>
                this.goToNext()
            );
        }
    }

    init() {
        // bind events
        this.bindEvents();

        // set properties on elements
        if (this.$items) {
            this.$items.forEach(($item, elementIndex) => {
                $item.style.animationDuration = `${this.props.speed}ms`;
            });
        }

        // set initial active item
        this.goTo(this.activeIndex);
    }

    goTo(newIndex: number) {
        if (
            this.$items &&
            newIndex <= this.numberOfItems - 1 &&
            newIndex > -1
        ) {
            this.$items.forEach(($item, elementIndex) => {
                if (elementIndex === newIndex) {
                    this.activeIndex = newIndex;
                    $item.setAttribute("data-carousel-item-active", "");
                } else {
                    $item.removeAttribute("data-carousel-item-active");
                }
            });
        }
    }

    goToPrevious() {
        const newIndex =
            this.activeIndex - 1 < 0
                ? this.numberOfItems - 1
                : this.activeIndex - 1;
        this.goTo(newIndex);
    }

    goToNext() {
        const newIndex =
            this.activeIndex + 1 > this.numberOfItems - 1
                ? 0
                : this.activeIndex + 1;
        this.goTo(newIndex);
    }
}

export default Carousel;
